/**
 * Creates a deferred Promise.
 * Unlike a regular Promise you can resolve or reject outside of its constructor.
 * This allows you to use it similar to a Subject in Reactive X.
 * Adapted from https://stackoverflow.com/questions/44728779/deferred-that-extends-promise.
 */
export class Deferred<T> implements Promise<T> {

  [Symbol.toStringTag]: string = 'Promise';

  private promise: Promise<T>
  private _resolve;
  private _reject;

  public constructor() {
    this.promise = new Promise((resolve, reject) => {
      this._resolve = resolve;
      this._reject = reject;
    });
  }

  public then<TResult1 = T, TResult2 = never>(
    onfulfilled?: ((value: T) => TResult1 | PromiseLike<TResult1>) | undefined | null,
    onrejected?: ((reason: any) => TResult2 | PromiseLike<TResult2>) | undefined | null
  ): Promise<TResult1 | TResult2> {
    return this.promise.then(onfulfilled, onrejected)
  }

  public catch<TResult = never>(
    onrejected?: ((reason: any) => TResult | PromiseLike<TResult>) | undefined | null
  ): Promise<T | TResult> {
    return this.promise.catch(onrejected)
  }

  public finally(onfinally?: () => void): Promise<T> {
    return this.promise.finally(onfinally);
  }

  public resolve(val: T): void {
    this._resolve(val);
  }

  public reject(reason: any): void {
    this._reject(reason);
  }

}
